module.exports = __webpack_public_path__ + "7a23ee9a65e43616f1a257f00e58e355.png";